import { useEffect, useState } from 'react';
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import { setGroupDetails, setVenueGroups } from './state';
import { useHistory, useParams } from 'react-router-dom';
import { CREATE_URL, SETTINGS } from '../../const/URL.const';
import { IVenueGroup } from './state/groupsManagement.reducer';

export function useVenueGroups(dispatch?: any, path?: string) {
  const [settings, setSettings] = useState<IVenueGroup | undefined>(undefined);
  const history = useHistory();
  const [searchText, setSearchText] = useState<string>("");
  const [searchIsLoading, setSearchIsLoading] = useState<boolean>(false);
  let { id } = useParams<{ id: string }>();

  const { callAPI: callGroups, isLoading } = useAPIV2<IVenueGroup[] | IVenueGroup>(APIExtensions.venueGroups, {
    canAPIGetCacheValue: true,
    onMountDisabled: true,
  });

  useEffect(() => {

    if (searchText.length > 0) {
      if (!searchIsLoading) {
        setSearchIsLoading(true);
      }
      callGroups(HTTPMethods.GET, {
        params: {
          "name_public": searchText
        }
      }).then((data) => {

        if (data.isSuccessful && data.data && dispatch) {
          dispatch(setVenueGroups(data.data as IVenueGroup[]))
          setSearchIsLoading(false);
        }

      })
    }else{
      if(!id){
        setGroupsListItems();
        dispatch(setGroupDetails(undefined))
      }
    }
    // eslint-disable-next-line  
  }, [searchText])

  useEffect(() => {
    if (id) {
      getGroupById(id)
    }
  // eslint-disable-next-line  
  }, [id])

  async function getGroupById(id: string) {
    try {
      const { data, isSuccessful } = await callGroups(HTTPMethods.GET, {
        query: id
      })
      if (isSuccessful) {
        setSettings(data as IVenueGroup);
        dispatch(setGroupDetails(data as IVenueGroup))
      }
    } catch (error) {
      console.log('error', error)
    }
  }


  function setGroupsListItems(){
    callGroups(HTTPMethods.GET, {
      yoelloAPIParams: { size: 20, include_disabled: true },
      params: {
        "sort_direction": "desc",
        "sort_field": "created_on"
      }
    }).then((response)=>{
       if(response.isSuccessful && response.data && dispatch){
        dispatch(setVenueGroups(response.data as IVenueGroup[]))
       }
    })
  }
  function onSelectGroup(id: string) {
    history.push(`${path}${SETTINGS}/${id}`)
  }
  function onCreateGroup() {
    history.push(`${path}/${CREATE_URL}`)
  }



  return {
    id,
    settings,
    getGroupById,
    setSearchText,
    onSelectGroup,
    onCreateGroup,
    callGroups,
    searchIsLoading,
    isGroupsLoading: isLoading,
    setGroupsListItems
  }
}
